import styled from 'styled-components';

export const ModalContentWrapper = styled.div`
  text-align: center;
`;

export const HeadingWrapper = styled.div`
  [class*='Headingstyle__Heading-sc'] {
    font-size: 36px;
    line-height: 40px;
    margin-bottom: 10px;
  }
`;

export const ButtonsAreaWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
`;

export const ButtonWrapper = styled.div`
  padding: 0.5em;

  button {
    width: 100%;
  }
`;
